import { IArtist } from "@maxeb/art-sdk";

export interface State {
  id: string;
  status: "init" | "ok" | "pending" | "error" | "success";
  confirmDelete: boolean;
  data: IArtist;
  oldName?: string;
  errors: { [key: string]: string };
  onChange?: (artist: IArtist) => void;
}
export type SetState = (state: State) => void;
export interface Props {
  id: string;
  onChange?: (artist: IArtist) => void;
}
export function initialState(props: Props): State {
  const { id, onChange } = props;

  return {
    id,
    status: "init",
    confirmDelete: false,
    data: {},
    errors: {},
    onChange,
  };
}
